// ProgramId import removed - now using string type instead
import { Dayjs } from "dayjs";

export enum ProgramStatus {
	Ongoing = "ONGOING",
	Scheduled = "SCHEDULED",
	Draft = "DRAFT",
	Ended = "ENDED",
}

export enum GlobalProgramStatusType {
	NoProgram = "NoProgram",
	ScheduledProgram = "ScheduledProgram",
	OngoingProgram = "OngoingProgram",
	EndingSoonProgramWithNoNext = "EndingSoonProgramWithNoNext",
	EndedLastProgram = "EndedLastProgram",
	EndedLastProgramDetailsMode = "EndedLastProgramDetailsMode",
}

export type GlobalProgramStatus =
	| NoProgramStatus
	| ScheduledProgramStatus
	| EndedLastProgramStatus
	| EndedLastProgramDetailsModeStatus
	| OngoingProgramStatus;

interface NoProgramStatus {
	type: GlobalProgramStatusType.NoProgram;
}

interface ScheduledProgramStatus {
	type: GlobalProgramStatusType.ScheduledProgram;
	startDate: Dayjs;
}

interface EndedLastProgramDetailsModeStatus {
	type: GlobalProgramStatusType.EndedLastProgramDetailsMode;
	endDate: Dayjs;
	programId: string;
}

interface EndedLastProgramStatus {
	type: GlobalProgramStatusType.EndedLastProgram;
	endDate: Dayjs;
	programId: string;
}

interface OngoingProgramStatus {
	type: GlobalProgramStatusType.OngoingProgram | GlobalProgramStatusType.EndingSoonProgramWithNoNext;
	startDate: Dayjs;
	endDate: Dayjs;
	programId: string;
}

export type ExtendableProgramStatusProps =
	| EndedLastProgramStatus
	| EndedLastProgramDetailsModeStatus
	| OngoingProgramStatus;
